import { insiderNotes, verifySteps } from "@/mocks/leakData";

export default function InsiderZone() {
  return (
    <section id="insider" className="bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* 左侧说明 */}
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.28em] text-accent-400">
              <i className="ri-shield-keyhole-line" />
              Insider
            </span>
            <h2 className="mt-2 font-heading text-3xl font-black text-background-50 md:text-4xl">
              内部信源专区
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/70">
              来自一线的实名受保护的内部声音。我们以更高证据门槛收录，并提供可追溯的核验进度。
            </p>

            {/* 核验流程 */}
            <div className="mt-8 space-y-4">
              {verifySteps.map((s) => (
                <div key={s.step} className="flex gap-4">
                  <span className="font-heading text-2xl font-black text-accent-400/80">
                    {s.step}
                  </span>
                  <div>
                    <h3 className="text-sm font-bold text-background-50">{s.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-background-100/60">
                      {s.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#submit"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition hover:bg-accent-400"
            >
              <i className="ri-lock-2-line" />
              成为受保护信源
            </a>
          </div>

          {/* 右侧信源卡片 */}
          <div className="flex flex-col gap-4 lg:col-span-7">
            {insiderNotes.map((n, i) => (
              <article
                key={n.title}
                className="rounded-xl border border-background-100/15 bg-background-50/5 p-5 transition hover:border-accent-500/40 hover:bg-background-50/10 md:p-6"
              >
                <div className="flex flex-wrap items-center gap-3">
                  <span
                    className={`rounded-sm px-2 py-1 text-[11px] font-bold ${
                      n.level.startsWith("A")
                        ? "bg-primary-600 text-background-50"
                        : "bg-accent-500 text-foreground-950"
                    }`}
                  >
                    {n.level}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-background-100/70">
                    <i className="ri-user-3-line" />
                    {n.who}
                  </span>
                  <span className="ml-auto inline-flex items-center gap-1 text-[11px] text-accent-300">
                    <i className="ri-time-line" /> {n.time}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-background-50">
                  {n.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-100/65">
                  {n.brief}
                </p>
                <div className="mt-4 flex items-center gap-2">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-primary-600/20 text-primary-400">
                    <i className="ri-lock-password-line text-[13px]" />
                  </span>
                  <span className="text-[11px] text-background-100/50">
                    原始证据已加密归档 · 对相关方匿名
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}